var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.65 4.931 1.052-.431h5.106l1.053.431L22.976 8H28.5v19.5h-25V8h6.034zM14.317 7.5 10.764 11H6.5v13.5h19V11h-3.753l-3.553-3.5zm1.683 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10.5 17a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
    clipRule: "evenodd"
  })));
};
export default SvgCamera;